import React, {useContext} from 'react';


import {useNewsletterDictionary} from 'src/hooks/dictionaries/useNewsletterDictionary';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {useDownloadReport} from 'src/modules/bulk-update/useDownloadReport';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FlatButton} from '@pb/kit-component-button';
import {FormattedDate} from '@pb/kit-component-formatters';
import {Icon, Icons} from '@pb/kit-component-icon';
import {LocaleContext} from '@pb/kit-context-locale';

import type {NewsletterHistory} from 'src/modules/profile/account/create-user/steps/users-settings/components/newsletters-settings/useNewsletterHistory';

const HEADERS = [
    'Newsletter',
    'Date Received',
];

type Props = {
    history: NewsletterHistory,
    newsletterLabels?: Record<string, string>,
};

export const DownloadNewsletterHistory = ({history, newsletterLabels: labelsProp}: Props) => {
    const disabled = !history.data.length;
    const {bulkDownload} = useEventTracking();
    const {locale} = useContext(LocaleContext);
    const {newsletterLabels: hookLabels} = useNewsletterDictionary({skip: !!labelsProp});
    const newsletterLabels = labelsProp ?? hookLabels;


    const startCSVDownload = useDownloadReport({
        fileName: 'newsletter-subscription-history',
        content: [
            ['', ''],
            ['From:', history.request.filters.period?.startDate
                ? FormattedDate.format({
                    value: history.request.filters.period.startDate,
                    format: mapDateFormat(locale.dateFormat, 'WORD'),
                }) as string
                : '--',
            ],
            ['To:', history.request.filters.period?.endDate
                ? FormattedDate.format({
                    value: history.request.filters.period.endDate,
                    format: mapDateFormat(locale.dateFormat, 'WORD'),
                }) as string
                : '--',
            ],
            [
                'Newsletter types:',
                `"${history.request.filters.newsletterTypes?.map(type => newsletterLabels[type]).join(', ')}"`,
            ],
            ['', ''],
            HEADERS,
            ...history.data.map(item => [
                `"${newsletterLabels[item.newsletterType] as string}"`,
                `"${FormattedDate.format({
                    value: item.sendingDate,
                    format: mapDateFormat(locale.dateFormat, 'NUMERIC', 'DATE_TIME'),
                }) as string}"`,
            ]),
        ],
    });

    return (
        <FlatButton
            startIcon={<Icon type={Icons.DOWNLOAD}/>}
            disabled={disabled}
            onClick={() => {
                startCSVDownload();
                bulkDownload({toolName: 'Newsletter Subscription History'});
            }}>
            <b>Download</b>
        </FlatButton>
    );
};
